import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=7972d92e&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=7972d92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972d92e",
  null
  
)

export default component.exports